import api from '../utils/apiConfig';

export const icd10API = {
  search: async (query = '', limit = 30) => {
    const params = { limit };
    if (query && query.trim()) params.q = query.trim();
    const response = await api.get('/icd10', { params });
    return response.data?.data || [];
  },
  list: async (params = {}) => {
    const response = await api.get('/icd10/list', { params });
    return response.data;
  }
};
